export default "__VITE_ASSET__ektHdcRi__"